export const isExpert = (bool) => {
  return {
    type: "IS_EXPERT",
    payload: bool,
  };
};

export const chekExpAcc = () => {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/isqea/isexpert", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token: localStorage.getItem("user_token") }),
      });

      if (!response.ok) {
        throw new Error(response.statusText);
      }

      const expert = await response.json();

      if (expert.message !== "Access Denied") {
        dispatch(isExpert(expert.result));
      } else {
        dispatch(isExpert(false));
      }
    } catch (error) {
      console.error("Error checking expert access:", error);
    }
  };
};

export const isExpertInFact = (bool) => {
  return {
    type: "IS_EXPERT_IN_FACT",
    payload: bool,
  };
};

export const checkExpInFac = () => {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/isqea/isexpertfact", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token: localStorage.getItem("user_token") }),
      });

      if (!response.ok) {
        throw new Error(response.statusText);
      }

      const expert = await response.json();

      if (expert.message !== "Access Denied") {
        dispatch(isExpertInFact(expert.result));
      } else {
        dispatch(isExpertInFact(false));
      }
    } catch (error) {
      console.error("Failed to check expert in fact:", error);
      dispatch(isExpertInFact(false));
    }
  };
};

export const isQuerist = (bool) => {
  return {
    type: "IS_QUERIST",
    payload: bool,
  };
};

export const chekQueryAcc = () => {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/isqea/isquerist", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token: localStorage.getItem("user_token") }),
      });

      if (!response.ok) {
        throw new Error(response.statusText);
      }

      const query = await response.json();

      if (query.message !== "Access Denied") {
        dispatch(isQuerist(query.result));
      } else {
        dispatch(isQuerist(false));
      }
    } catch (error) {
      console.error("Failed to check query account:", error);
      dispatch(isQuerist(false));
    }
  };
};

export const isAdmin = (bool) => {
  return {
    type: "IS_ADMIN",
    payload: bool,
  };
};

export const chekAdminAcc = () => {
  return async (dispatch) => {
    try {
      const response = await fetch("/api/isqea/isadmin", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token: localStorage.getItem("user_token") }),
      });

      if (!response.ok) {
        throw new Error(response.statusText);
      }

      const admin = await response.json();

      if (admin.message !== "Access Denied") {
        dispatch(isAdmin(admin.result));
      } else {
        dispatch(isAdmin(false));
      }
    } catch (error) {
      console.error("Failed to check admin access:", error);
      dispatch(isAdmin(false));
    }
  };
};

export const chekHTTPS = () => {
  return () => {
    if (
      window.location.protocol !== "https:" &&
      window.location.hostname !== "localhost"
    ) {
      window.location.replace(
        `https:${window.location.href.substring(
          window.location.protocol.length
        )}`
      );
    }
  };
};
